
'use strict'

import Wow from "../utils/Wow";
import Preloader from "../utils/Preloader";
import BannerCookies from "../components/BannerCookies";
import Header from "./components/Header"; // Solo lo importo para que exista
import Auth from "../libs/API/Auth";
import { isMobileDevice, registerGaEvents } from "../utils/Utils";


class App {
    constructor() {
        this.main = document.getElementById('app');
        
        this._section = Section != null ? new Section() : null;

        if (isMobileDevice()) {
            this.main.classList.add('is-mobile-device');
        }

        registerGaEvents();
        
        Auth.initSession();

        let preloader = new Preloader();
        preloader.preload(this._onPreloadDone.bind(this));

        setTimeout(()=>{
            Wow.init();
        }, 0);
    }

    _onPreloadDone(){
        document.body.classList.remove('loading');
        window.addEventListener("beforeunload", function() {
            const currentURL = window.location.href;
            if (!currentURL.includes("ad-designs")) {
                localStorage.setItem("lastVisited", currentURL);
            }
        });
    }

}

export default App;
